/**
 * @title rxprescription.js: Sub-module for Rx pages
 * @description This module is used to handle various prescription-related tasks
 * @dependency checkout_helper.js, address.js, addressSelectionDialog.js, addressForm.js
 */
define(['rxaddresshelper'], function(rxAddressHelper) {	
	
	var rxRefillPrescription = {
			
		init : function(options) {
			rxRefillPrescription.sortPrescriptionsJSON();
			rxRefillPrescription.bindEvents();
			rxRefillPrescription.showHideShippingAndBillingSection();

			if (options != undefined) {
				rxAddressHelper.init(options);				
			}

		},
		
		currentAddressId: '',
		currentAddressType: '',
		
		showHideShippingAndBillingSection: function() {

			$('#ship-when-ready').click(function() {
				$('#billing-and-shiping').show();
				if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
					$('#complete-prescription-request-button').prop('disabled', true);
				}
			});
			
			$('#notify-when-ready').click(function() {
				$('#billing-and-shiping').hide();
				if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
					$('#complete-prescription-request-button').prop('disabled', false);
				}
			});
		},
		
		/**
		 * Binding events
		 */
		bindEvents: function() {
			if (rxRefillPrescription.refillPrescriptionInfoForm.getForm().length) {
				rxRefillPrescription.refillPrescriptionInfoForm.getForm().find('input[name=submit-for-review]').unbind('click')
						.on('click', rxRefillPrescription.submitForReview);
				rxRefillPrescription.setUpSortEventListeners();	
			}
		},
		refillPrescriptionInfoForm : {
			/**
			 * Gets refill prescription info form
			 * @return {form} Refill prescription info jquery form
			 */
			getForm: function() { 
				return $('#RefillPrescriptionInfoForm');
			},
			/**
			 * Checks if refill prescription form is valid to be submitted
			 * @return {Boolean} True if form is valid
			 */
			isValid: function() {
				return rxRefillPrescription.getSelectedPrescriptionIds().length;
			}
		},
		refillPrescriptionSubmitForm : {
			/**
			 * Gets refill prescription submit form
			 * @return {form} Refill prescription submit jquery form
			 */
			getForm: function() { 
				return $('#refill-prescription-order-verification');
			}
		},
		url: {
			REMOVE_DRUG: '/AjaxPharmacyRemoveDrugFromSessionCmd',
			CHANGE_PRESCRIPTION_STATUS: '/AjaxPharmacyPrescriptionActiveStatusChangeCmd',
			CHANGE_PRESCRIPTION_AUTOREFILL: '/AjaxPharmacyPrescriptionAutoRefillCmd',
		},
		/**
		 * Sorts active and inactive prescription lists for webpage display
		 * @param (string) listType		Type of the list to order(Active, Inactive)
		 * @param (string) sortType 	Selected sorting type  
		 */
		sortPrescriptionsJSON : function(listType,sortType) {
			
			//On initial page load, sort by order date
			if(listType == "undefined" && sortType  == "undefined" || listType == undefined && sortType  == undefined || listType == null && sortType  == null){
				//Set all selects to initial value Sort by order date
				if (typeof activePrescriptions != "undefined" && activePrescriptions.length > 0){
					activePrescriptions.sort(rxRefillPrescription['prescriptionSortByLastOrderedDesc']);
					$('#activeRefills-sort').closest('.row').show();
				}else{
					$('#activeRefills-sort').closest('.row').hide();
				}
				if (typeof inactivePrescriptions != "undefined" && inactivePrescriptions.length > 0){
					inactivePrescriptions.sort(rxRefillPrescription['prescriptionSortByLastOrderedDesc']);
					$('#inactiveRefills-sort').closest('.row').show();
				}else{
					$('#inactiveRefills-sort').closest('.row').hide();
				}
				if (typeof onFilePrescriptions != "undefined" && onFilePrescriptions.length > 0){
					onFilePrescriptions.sort(rxRefillPrescription['prescriptionSortByLastOrderedDesc']);
					$('#onFileRefills-sort').closest('.row').show();
				}else{
					$('#onFileRefills-sort').closest('.row').hide();
				}
			}else if(listType == "activePrescriptions" && typeof activePrescriptions != "undefined"){
				activePrescriptions.sort(rxRefillPrescription[sortType]);	
			}else if(listType == "inactivePrescriptions" && typeof inactivePrescriptions != "undefined"){
				inactivePrescriptions.sort(rxRefillPrescription[sortType]);
			}else if(listType == "onFilePrescriptions" && typeof onFilePrescriptions != "undefined"){
				onFilePrescriptions.sort(rxRefillPrescription[sortType]);
			}
		},
		/**
		 * Sets up event listeners for sorting refill prescriptions lists 
		 */
		setUpSortEventListeners: function(){
			$('#activeRefills-sort').off('change').on('change', function() {
				COSTCO.rxRefillPrescription.sortPrescriptionsJSON("activePrescriptions" ,this.value)
				active_loadPrescriptionLists();
			});
			$('#inactiveRefills-sort').off('change').on('change', function() {
				COSTCO.rxRefillPrescription.sortPrescriptionsJSON("inactivePrescriptions" ,this.value)
				inactive_loadPrescriptionLists();
			});
			$('#onFileRefills-sort').off('change').on('change', function() {
				COSTCO.rxRefillPrescription.sortPrescriptionsJSON("onFilePrescriptions" ,this.value)
				onFile_loadPrescriptionLists();
			});
		},
		
		/**
		 * Orders prescription list by order date
		 */
		prescriptionSortByLastOrderedDesc: function(prescriptionA, prescriptionB) {
			let prescriptionALastOrderedDate = prescriptionA.lastOrdered ? prescriptionA.lastOrdered : prescriptionA.lastOrderedDate ? prescriptionA.lastOrderedDate : '';
			let prescriptionBLastOrderedDate = prescriptionB.lastOrdered ? prescriptionB.lastOrdered : prescriptionB.lastOrderedDate ? prescriptionB.lastOrderedDate : '';			
			return new Date(prescriptionBLastOrderedDate).getTime() - new Date(prescriptionALastOrderedDate).getTime();
		},
		
		/**
		 * Orders prescription list by drug name
		 */
		prescriptionSortByDrugName: function(prescriptionA, prescriptionB) {
			let prescriptionADrugName = prescriptionA.drugDescription ? prescriptionA.drugDescription : '';
			let prescriptionBDrugName = prescriptionB.drugDescription ? prescriptionB.drugDescription : '';		
			return ((prescriptionADrugName.toLowerCase() < prescriptionBDrugName.toLowerCase()) ? -1 : ((prescriptionADrugName.toLowerCase() > prescriptionBDrugName.toLowerCase()) ? 1 : 0));
		},
		
		/**
		 * Orders prescription list by refills left Treat N/A as 999(infinite refills left) so they show in end of sorted list
		 */
		prescriptionSortByRefillsLeft: function(prescriptionA, prescriptionB) {
			let prescriptionARefillsLeft = prescriptionA.refillsLeft ? !isNaN(prescriptionA.refillsLeft) ? prescriptionA.refillsLeft : 999 : 999;
			let prescriptionBRefillsLeft = prescriptionB.refillsLeft ? !isNaN(prescriptionB.refillsLeft) ? prescriptionB.refillsLeft : 999 : 999;			
			return prescriptionARefillsLeft - prescriptionBRefillsLeft;
		},
		
		/**
		 * Orders prescription list by auto refill, possible values 0-2 N/A, if the value is N/A or empty replace it with number 4
		 */
		prescriptionSortByAutoRefill: function(prescriptionA, prescriptionB) {
			let prescriptionAAutoRefill = prescriptionA.autoRefill ? !isNaN(prescriptionA.autoRefill) ? prescriptionA.autoRefill : 4 : 4;
			let prescriptionBAutoRefill = prescriptionB.autoRefill ? !isNaN(prescriptionB.autoRefill) ? prescriptionB.autoRefill : 4 : 4;	
			return prescriptionAAutoRefill - prescriptionBAutoRefill;
		},
		
		noRefillPopup: function (isMedicare) {
			var popupDiv = '#no-refill-popup';
			if(isMedicare){
				popupDiv = '#no-refill-popup-medicare';
			}
			
			COSTCO.dialog.createExtDialogBox({
				title:messages.REFILL_PRESCRIPTION_TITLE_NOREFILL,
				body: $(popupDiv).html(),
				primary: messages.JS_DIALOG_OK,
				primary_event: ()=> {
			          COSTCO.dialog.close();
				},
			
			});
			
		},
		
		/**
		 * Creates active/inactive prescriptions table with pagination, based on template
		 * @param  {string} status               Prescription status (active / inactive)
		 * @param  {string} prescriptionsBlockId HTML block ID to be populated with prescription rows
		 * @param  {number} pageNum              Page number to show
		 * @param  {number} rowsNum              Prescription rows per page
		 * @param  {number} numOfPages           Total number of pages
		 */
		createPrescriptionsSection : function(status, prescriptionsBlockId, pageNum, rowsNum, numOfPages, totalRecordsNum, pagingRequest) {
			
			$('#' + prescriptionsBlockId).html('');
			
			let prescriptions = this.getPrescriptionsJSON(status, pageNum, rowsNum);
			
			$.each(prescriptions, function(index, value) {
				
				value.groupIndex = index +1;
				
				let template = COSTCO.util.tmpl(status + '_refill_prescription_row', value);

				template = $(template);

				if (value.checked == true) {
					template.find('#prescriptionNumber_' + value.prescriptionId).prop('checked', true);
				}
				
				template.find('#autoRefillEnabled_' + value.prescriptionId).prop('checked', value.autoRefill == '1' ? true : false);
				template.find('#autoRefillDisabled_' + value.prescriptionId).prop('checked', value.autoRefill == '0' ? true : false);
				let autoRefill="<a href='javascript:COSTCO.rxRefillPrescription.noRefillPopup(false);'>N/A</a>";
				if(template.find('#autoRefillDisabled_' + value.prescriptionId) && (value.autoRefill == 3) && value.onFile == "false") {
					setTimeout(function(){ 
					let clearView = '';
					
					$('#autoRefillDiv_' + value.prescriptionId).html(clearView);
					$('#autoRefillDiv_' + value.prescriptionId).html(autoRefill);
					}, 100);
				}
				
				if (value.onFile == "true" && value.active == "false") {
					template.find('#autoRefillDiv_' + value.prescriptionId).html(autoRefill);
					template.find('#lastOrderedDiv_' + value.prescriptionId).html("New");
				}
					
				$('#' + prescriptionsBlockId).append(template);
			});
				
			// Add class 'active-page' to current page
			$('[page-number^="' + status + '-"]').removeClass('active-page');
			$('[page-number="' + status + '-' + pageNum + '"]').addClass('active-page');
			
			// Bind events to arrows for Previous and Next page
			$('#' + status + '-previous-page').unbind().on('click', function () {
				let previousPage = (pageNum - 1 > 0) ? (pageNum - 1) : pageNum;
				COSTCO.rxRefillPrescription.createPrescriptionsSection(status, prescriptionsBlockId, previousPage, rowsNum, numOfPages, totalRecordsNum);
			});
			
			$('#' + status + '-next-page').unbind().on('click', function () {
				let nextPage = (pageNum + 1 <= numOfPages) ? (pageNum + 1) : pageNum;
				COSTCO.rxRefillPrescription.createPrescriptionsSection(status, prescriptionsBlockId, nextPage, rowsNum, numOfPages, totalRecordsNum);
			});
			
			// Hide Show logic for previous and next arrows
			if (pageNum == 1) {
			  $('#' + status + '-previous-page').hide();
			} else if (pageNum > 1 && numOfPages > 1) {
			  $('#' + status + '-previous-page').show();
			}
			
			if (pageNum == numOfPages) {
			  $('#' + status + '-next-page').hide();
			} else if(pageNum < numOfPages) {
			  $('#' + status + '-next-page').show();
			}
			
			// Show paging navigation
			let firstRecordIndex = (pageNum - 1) * rowsNum + 1;
			let lastRecordIndex = (pageNum * rowsNum < totalRecordsNum) ? (pageNum * rowsNum) : totalRecordsNum; 
			$('#' + status + '-paging-navigation').html(COSTCO.util.tmpl('prescription_upper_paging_navigation', {
				firstRecordIndex: firstRecordIndex,
				lastRecordIndex: lastRecordIndex,
				totalRecordsNum: totalRecordsNum
			}));
			
			if (pagingRequest) {
				$(window).scrollTop($('#' + prescriptionsBlockId).offset().top - 200);
			}
		},
		
		/**
		 * Gets JSON array of active or inactive prescriptions to be displayed on page
		 * @param {string} status 	Status of prescriptions to display ('active' | 'inactive')
		 * @param {number} pageNum 	Page number; Default set to 1
		 * @param {number} rowsNum 	Number of records to be displayed; Default set to 10
		 * @return Prescriptions JSON Array to be displayed on page, based on pageNum, rowsNum count and prescription status
		 */
		getPrescriptionsJSON : function(status, pageNum, rowsNum) {
							
			let resultArray = [];
			
			if (pageNum == undefined) {
				pageNum = 1;
			}
			
			if (rowsNum == undefined) {
				rowsNum = 10;
			}
			
			let beginIndex = (pageNum * rowsNum) - rowsNum;
			let endIndex = pageNum * rowsNum - 1;
			
			let prescriptionsJson = [];
			if (status == 'active') {
				prescriptionsJson = activePrescriptions;
			} else if (status == 'inactive') {
				prescriptionsJson = inactivePrescriptions;
			} else if (status == 'onFile') {
				prescriptionsJson = onFilePrescriptions;
			}
			
			$.each(prescriptionsJson, function(index, value) {
				if (beginIndex <= index && index <= endIndex) {
					resultArray.push(value);
				}
			});
			
			return resultArray;
		},
		/**
		 * Returns prescriptions selected by user based on prescription status. If no status is provided, get selected prescriptions from both active and inactive lists
		 * @param {string} status Prescription status (active|inactive). Could be ommited if want to ceheck both active and inactive lists
		 * @return {Array} Selected prescriptions which have property checked=true
		 */
		getSelectedPrescriptionIds: function(status) {

			let selectedPrescriptions = [];
			let tmpPrescriptionsArray = []
			
			if (status == undefined) {
				$.merge(tmpPrescriptionsArray, activePrescriptions);
				$.merge(tmpPrescriptionsArray, inactivePrescriptions);
				$.merge(tmpPrescriptionsArray, onFilePrescriptions);

			} else if (status == 'active') {
				tmpPrescriptionsArray = activePrescriptions;
			} else if (status == 'inactive') {
				tmpPrescriptionsArray = inactivePrescriptions;
			} else if (status == 'onFile') {
				tmpPrescriptionsArray = onFilePrescriptions;
			}
			$.each(tmpPrescriptionsArray, function(index, value) {
				if(value.checked == true) {
					selectedPrescriptions.push(value.prescriptionId);
				}
			});

			return selectedPrescriptions;
				
		},
		/**
		 * Removes the drug from order prescription list on Verification Page
		 * @param {int} rxNumber 	rxNumber of prescription to be removed
		 */
		removeDrug : function(rxNumber) {
			
			let key = [rxNumber];
			
			if (key.length !== 0) {
				
				COSTCO.Checkout.ajax_update_state({
          error_container: '#notification-message',
          method: 'POST',
          url: rxRefillPrescription.url.REMOVE_DRUG,
          data: {drugMapKey:key, fromPage:rxCheckoutPageName},
          dataType: 'json',
        })
					
			} else {
				console.log('rxNumber empty!');
			}
		},
		/**
		 * Toggles show / hide display of prescription list on webpage
		 * @param {String} section 	specifies which prescription list section to toggle
		 */
		showHideToggle : function(event) {

			const showHideButton = $(event.currentTarget);
			const divWrapper = $(showHideButton).closest('.prescription-info-list-wrapper');
			const prescriptionWrapper = $(divWrapper).find('.prescription-info-list')
			const icon = $(showHideButton).find('i');
			const span = $(showHideButton).find('span');
			const activeToggle = $(divWrapper).find('#active-prescriptions-toggle');
			const inactiveToggle = $(divWrapper).find('#inactive-prescriptions-toggle');
			const onFileToggle = $(divWrapper).find('#onFile-prescriptions-toggle');

			if ($(showHideButton).hasClass('show-list')) {
				$(showHideButton).removeClass('show-list');
				$(icon).removeClass('rotate270');
				$(showHideButton).addClass('hide-list');
				$(icon).addClass('rotate90');
				$(span).text(messages.RWD_COMPARE_SHOW);
				$(showHideButton).find('.paging-navigation .text-right').hide();
				$(prescriptionWrapper).hide()
			} else {				
				$(showHideButton).removeClass('hide-list');
				$(icon).removeClass('rotate90');
				$(showHideButton).addClass('show-list');
				$(icon).addClass('rotate270');
				$(span).text(messages.RWD_COMPARE_HIDE);
				$(showHideButton).find('.paging-navigation .text-right').show();
				$(prescriptionWrapper).show()
			};

			if ($(activeToggle).hasClass('show-list')) {
				$(activeToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_ACTIVE_TOGGLE);
			} else if ($(activeToggle).hasClass('hide-list')) {
				$(activeToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_ACTIVE_TOGGLE);
			} else if ($(inactiveToggle).hasClass('show-list')) {
				$(inactiveToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_INACTIVE_TOGGLE);
			} else if ($(inactiveToggle).hasClass('hide-list')) {
				$(inactiveToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_INACTIVE_TOGGLE);
			} else if ($(onFileToggle).hasClass('show-list')) {
				$(onFileToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_HIDE_ONFILE_TOGGLE);
			} else if ($(onFileToggle).hasClass('hide-list')) {
				$(onFileToggle).attr('aria-label', messages.REFILL_PRESCRIPTION_SHOW_ONFILE_TOGGLE);
			} else {
				$(onFileToggle).attr('aria-label', " ");
			};
			
		},
		
		/**
		 * Opens AutoRefill Reminder dialog.
		 */
		openEnableAutoRefillReminderDialog: function() {
			
			COSTCO.dialog.createExtDialogBox({
				title: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_TITLE,
				body: messages.ENABLE_AUTOREFILL_REMINDER_DIALOG_CONTENT,
				primary: messages.JS_DIALOG_OK,
			});
		},
		/**
		 * Opens information dialog when user clicks make inactive / active button.
		 */
		openChangePrescriptionStatusInfoDialog: function() {
			
			COSTCO.dialog.createExtDialogBox({
				title: messages.PRESCRIPTION_PHARMACY__Info_DialogTitle,
				body: messages.HDREFILL_PRESCRIPTION_PHARMACY__SelectAPrescriptionActiveStatusChange_DialogText,
				primary: messages.JS_DIALOG_OK,
			});
		},
		/**
		 * Handles on click auto refill radio button
		 * @param {number} autoRefill       Radio button user clicked (0 - off | 1 - on)
		 * @param {number} prescriptionId 	Prescription id
		 * @param {string} status        	 	Prescription status (active | inactive)
		 */
		managePrescriptionAutoRefill: function(autoRefill, prescriptionId, status) {
			COSTCO.Checkout.ajax_update_state({
		        error_container: '#notification-message',
		        method: 'POST',
		        url: rxRefillPrescription.url.CHANGE_PRESCRIPTION_AUTOREFILL,
		        data: { prescriptionId: prescriptionId, autoRefill: autoRefill, status: status },
		        dataType: 'json',
		        done: function(data, textStatus, jqXHR, options) {
	        		if (data.payload.data.numberOfPrescriptionsUpdated != 1) {						
							rxRefillPrescription.revertAutoRefillUserSelection(prescriptionId);	
					} else {
						if (data.payload.data.patientAutoRefillReminder == "false" && autoRefill == 1) {
							rxRefillPrescription.openEnableAutoRefillReminderDialog();
						}
						let prescriptionListToUpdate = activePrescriptions;
						if (options.data.status == 'inactive') {
							COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
							prescriptionListToUpdate = inactivePrescriptions;
						}
						prescriptionListToUpdate.find((result, index) => {
						    if (result.prescriptionId == prescriptionId) {
								prescriptionListToUpdate[index].autoRefill = autoRefill;
						    }
						});
					}
				},
		        ajax_update_post_done: function() {
		        	rxRefillPrescription.bindEvents();
				}
			});
		},
		/**
		 * Reverts auto refill user selection to initial state from prescription JSON 
		 * @param  {number} prescriptionId 	Id of prescription to revert
		 */
		revertAutoRefillUserSelection: function(prescriptionId) {

			let presc = rxRefillPrescription.getPrescriptionJSONById(activePrescriptions, prescriptionId);
			if (presc == undefined) {
				presc = rxRefillPrescription.getPrescriptionJSONById(inactivePrescriptions, prescriptionId);
			}
			
			if (presc != undefined) {

				if (presc.autoRefill == 0) {
					$('#autoRefillDisabled_' + prescriptionId).prop('checked', true);		

				} else if (presc.autoRefill == 1) {
					$('#autoRefillEnabled_' + prescriptionId).prop('checked', true);
				}
			} 

		},

		/**
		 * Iteraters through provided JSON array and updates 'checked' property to match user selection
		 * @param {JSON Array} prescriptionJSON 				Prescription JSON array to update
		 * @param {number} 		 prescriptionId   				User selected prescription
		 * @param {String}     ajaxResponseAutoRefill		Ajax response with autorefill option set by command
		 */
		updatePrescriptionAutoRefillInJSON: function(prescriptionJSON, prescriptionId, ajaxResponseAutoRefill) {
				$.each(prescriptionJSON, function(index, value) {
					if (value.prescriptionId == prescriptionId) {
						value.autoRefill = ajaxResponseAutoRefill;
					}
				});
		},
		/**
		 * Gets prescription JSON from input JSON array by ID
		 * @param  {JSON Array} 	prescriptionJSON 	Prescription JSON array
		 * @param  {number} 			prescriptionId   	Id of prescription to find in JSON array
		 * @return {JSON Object}  Found prescription
		 */
		getPrescriptionJSONById: function(prescriptionJSON, prescriptionId) {

			let json;
			$.each(prescriptionJSON, function(index, value) {
				if (value.prescriptionId == prescriptionId) {
					json = value;
					return false;
				}
			});

			return json;
		},
		
		/**
		 * Handles on click prescription selection
		 * @param {number} prescriptionId 	Prescription id
		 * @param {string} status        	 	Prescription status (active | inactive)
		 * @param {string} element       	 	HTML element user clicked on
		 */
		managePrescriptionSelection: function(prescriptionId, status, element) {
			
			COSTCO.util.notification.clearNotification();
			
			if (status == 'active') {
				rxRefillPrescription.setPrescriptionSelectionInJSON(activePrescriptions, prescriptionId, element);
			} else if (status == 'inactive') {
					rxRefillPrescription.setPrescriptionSelectionInJSON(inactivePrescriptions, prescriptionId, element);
			} else if (status == 'onFile') {
				rxRefillPrescription.setPrescriptionSelectionInJSON(onFilePrescriptions, prescriptionId, element);
			}

		},
		/**
		 * Iterates through provided JSON array and sets 'checked' property to match user selection
		 * @param {JSON Array} prescriptionJSON 	Prescription JSON array to update
		 * @param {number} prescriptionId   			User selected prescription
		 * @param {Object} element          			Selected prescription input html element
		 */
		setPrescriptionSelectionInJSON: function(prescriptionJSON, prescriptionId, element) {
			$.each(prescriptionJSON, function(index, value) {
				if (value.prescriptionId == prescriptionId) {
					value.checked = $(element).prop('checked');
				}
			});
		},
		/**
		 * Submits refill prescription for review
		 */
		submitForReview: function() {
			
			if (rxRefillPrescription.refillPrescriptionInfoForm.isValid()) {
				let form =  rxRefillPrescription.refillPrescriptionInfoForm.getForm();
				form.find('input[id="rxPrescriptionNumber"]').val(rxRefillPrescription.getSelectedPrescriptionIds().toString());
				form.submit();

			} else {
				COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR,[messages.ERR_NO_REFILL_PRESCRIPTION_SELECTED], true, undefined);
			}
		},
		/**
		 * Changes selected prescriptions status from active / inactive to opposite
		 * @param {String} status		Prescription status (active | inactive)
		 */
		changePrescriptionStatus: function(status) {
			let selectedPrescriptionIds = rxRefillPrescription.getSelectedPrescriptionIds(status);
			if (selectedPrescriptionIds.length) {
				
				COSTCO.Checkout.ajax_update_state({
			          error_container: '#notification-message',
			          method: 'POST',
			          url: rxRefillPrescription.url.CHANGE_PRESCRIPTION_STATUS,
			          data: {
				          	selectedPrescriptionIds: selectedPrescriptionIds.toString(), 
				          	isActive: (status == 'active' || status == 'onFile') ? true : false
			          },
			          dataType: 'json',
			          ajax_update_post_done: function() {
			        	  COSTCO.rxRefillPrescription.sortPrescriptionsJSON();
			        	  rxRefillPrescription.bindEvents();
			        	  if (typeof onFilePrescriptions != "undefined" && onFilePrescriptions.length > 0) onFile_loadPrescriptionLists();
			        	  if (typeof inactivePrescriptions != "undefined" && inactivePrescriptions.length > 0) inactive_loadPrescriptionLists();
			        	  if (typeof activePrescriptions != "undefined" && activePrescriptions.length > 0) active_loadPrescriptionLists();
					  },
			          error: function() {
			          		console.log("There was an error processing prescription status change.");
			          }
			    })
			} else {
				rxRefillPrescription.openChangePrescriptionStatusInfoDialog();
			}
		},
	}

	if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
	} 
	
	window.COSTCO.rxRefillPrescription = rxRefillPrescription;
		
	return rxRefillPrescription;
    
});



// WEBPACK FOOTER //
// ./js/rx/rxrefillprescription.js